import { AxiosResponse } from "axios";
import { microserviceApiAxios } from "../../microservice-api.axios";
import { microserviceApiRoutes } from "../../microservice-api.routes";

export const verifyDevicesAgents = (data: any) => {
  const url = microserviceApiRoutes.v1.agents.devices.verify();
  return microserviceApiAxios.post(url, data).then((res) => res.data);
};
